import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import TextsmsIcon from "@mui/icons-material/Textsms";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import useStyles from "./DoodleHistoryStyle.js";

export default function DoodleHistory(props) {
  const uiClasses = useStyles();

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <colgroup>
          <col width="50%" />
          <col width="20%" />
          <col width="20%" />
        </colgroup>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell align="center">Elimination Date</TableCell>
            <TableCell align="center">Tooltip and Images</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {props.doodleHistory.map((doodle) => (
            <TableRow key={doodle.id}>
              <TableCell>
                <a href={doodle.url} target="_blank" rel="noreferrer">
                  {doodle.title}
                </a>

                {doodle.dedicatedForNewUser && (
                  <Tooltip title="Dedicated to the new users">
                    <SupervisedUserCircleIcon className={uiClasses.newUsersIcon} />
                  </Tooltip>
                )}
              </TableCell>

              <TableCell align="center">
                {new Date(doodle.eliminationDate).toLocaleDateString()}
              </TableCell>

              <TableCell align="center" className={uiClasses.iconColumn}>
                <Tooltip title={doodle.tooltip}>
                  <TextsmsIcon color="primary" className={uiClasses.icon} />
                </Tooltip>

                <a
                  className={uiClasses.icon}
                  href={doodle.desktopImage}
                  target="_blank"
                  rel="noreferrer"
                >
                  <DesktopMacOutlinedIcon />
                </a>

                <a
                  className={uiClasses.icon}
                  href={doodle.mobileImage}
                  target="_blank"
                  rel="noreferrer"
                >
                  <SmartphoneIcon />
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
